export type { LiteYoutubeProps } from './interface';
export { LiteYoutube } from './LiteYoutube';
